module.exports = __webpack_public_path__ + "static/media/additional-services-offered.26445bbf.svg";